import React, { Component } from 'react';
import { Bar } from 'react-chartjs-2';
import { Progress, Tooltip, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import FD from '../../RestAPI/fetchData';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import App_data from '../../config/App_data';
import language from '../../../assets/languages/language';
import EASubscriptionCheck from '../../RestAPI/EASubscription';
import PartnerEASubscriptionCheck from '../../RestAPI/PartnerSubscription/EASubscription';
import Loader from '../../../common/loader';
import AppRoutes from '../../config/AppRoutes';
import { Y_AXIS_SCALES } from '../../../common/constant';
import { renderHTMLContent, renderSanitizedHTML } from '../../../common/function';
import EmailResubscribe from '../../../components/EmailResubscribe';
import {autorun} from "mobx";
import userStore from "../../../store/userStore";
let i = '';
/* eslint-disable */
class GMATDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      reportAnswerStatus: false,
      reportEditStatus: false,
      reportEditId: '',
      MessageContent: `${language.LC().ARE_YOU_SURE_TO_DELETE_THIS}`,
      MessageTitle: `${language.LC().CONFIRM}`,
      items_val: '',
      item_status: '',
      dropdownOpen: false,
      ValidToken: false,
      toggle: true,
      token: '',
      idname: '',

      videoFlashReport: [],
      flashreport: [], //All Flash question Store

      savedquestion: [],
      savedvideo: [],

      reportquestion: [],
      reportsvideo: [],

      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,
      progress_bar_zero: [],
      progress_bar: [],
      progress_bar_slider: [],
      main_bargraph_data: '',
      // bar_chapter: '',
      bar_main_user: [],
      bar_main_class: [],
      main_ea_bar_main_user: [],
      main_ea_bar_main_class: [],
      main_ea_progress_bar_zero: [],
      main_ea_progress_bar: [],
      main_ea_progress_bar_slider: [],
      verbal_bar_main_user: [],
      verbal_bar_main_class: [],
      verbal_progress_bar_zero: [],
      verbal_progress_bar: [],
      verbal_progress_bar_slider: [],
      integrated_reasoning_bar_main_user: [],
      integrated_reasoning_bar_main_class: [],
      integrated_reasoning_progress_bar_zero: [],
      integrated_reasoning_progress_bar: [],
      integrated_reasoning_progress_bar_slider: [],
      startDate: '',
      startDate_second: '',
      send_startDate: '',
      send_startDate_second: '',
      more_detail_button: `${language.LC().I_WANT_MORE_DETAILS}`,
      show_outer: 'hide_block',
      chapters: '',
      reportAnswerId: '',
      subreadings_status: false,
      display_main_loader: 'show_block',
      display_loader: 'hide_block',
      deleteCSS: 'fa fa-trash mark-action-btn-dashboard',
      viewCSS: 'fa fa-eye mark-action-btn-dashboard',
      EditCSS: 'fa fa-pencil-square-o mark-action-btn-dashboard',
      viewREPORTCSS: 'fa fa-exclamation-circle fa-rotate-180 mark-action-btn-dashboard',
      ErrorMessage: '',
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      activeTabSavedcards: 0,
      activeTabReportcards: 0,
      activeTabSaved: '1',
      activeTabReports: '1',
      type: '',
      tooltips: [
        {
          placement: `${language.LC().SEPARATE_YOUR_RESULT}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().YOU_CAN_SEE}`,
          text_align: 'left',
        },
        {
          placement: `${language.LC().THAT_SPECIFIC_NOTES}`,
          text_align: 'left',
        },
      ],
      showFreePremium: false,
      selectedmenu: 'ea',
      isVideo: true,
      qpLoader: true,
      npLoader: true,
      savedLoader: true,
      flashLoader: true,
      reportLoader: true,
      content_type: ['Quant', 'Verbal', 'Integrated Reasoning'],
      questionShowFreePremium: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.toggleAlert = this.toggleAlert.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleClose = this.toggleClose.bind(this);
    this.toggleCloseReport = this.toggleCloseReport.bind(this);
    this.toggleAlertReport = this.toggleAlertReport.bind(this);
    this.CloseEditQuesReport = this.CloseEditQuesReport.bind(this);
    this.OpenEditQuesReport = this.OpenEditQuesReport.bind(this);
    this.CloseEditVideoReport = this.CloseEditVideoReport.bind(this);
    this.OpenEditVideoReport = this.OpenEditVideoReport.bind(this);
    this.toggleDone = this.toggleDone.bind(this);
    this.onContactChange = this.onContactChange.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen,
    });
  }

  toggleAlert(card) {
    this.setState({
      alert_status: !this.state.alert_status,
      item_status: card,
    });
  }

  toggleClose() {
    this.setState({
      alert_status: !this.state.alert_status,
      items_val: '',
      item_status: '',
    });
  }

  toggleAlertReport(item, data, e) {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: item.id,
      type: data,
    });
  }
  deleteFlashCard = async (type, id, question_type) => {
    const { idname: id_name, token } = this.state;
    const payload = {
      id_name,
      token,
      type: type,
      question_type,
      exam: 'ea',
      level: '',
      item_id: id,
    };
    await FD.callAPI(`${App_data.backend_api}/question_bank_2024/deleteFlashCard`, payload);
  };
  toggleCloseReport() {
    this.setState({
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      type: '',
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      SubjectErrorMessage: '',
      CommentErrorMessage: '',
      ErrorMessage: '',
      contactStatus: false,
    });
  }

  OpenEditQuesReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      quesReport: item.comment,
      type: 'quesReport',
    });
  }

  OpenEditVideoReport(item, e) {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: item.id,
      videoReport: item.comment,
      type: 'videoReport',
    });
  }

  CloseEditQuesReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      quesReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  CloseEditVideoReport() {
    this.setState({
      reportEditStatus: !this.state.reportEditStatus,
      reportEditId: '',
      videoReport: '',
      type: '',
      ErrorMessage: '',
    });
  }

  onContactChange(data, index, type) {
    if (!this.state.contactStatus) {
      this.setState({
        contactID: data.id,
        contactType: type,
        contactIndex: index,
        contactStatus: true,
      });
    } else {
      this.setState({
        contactID: '',
        contactType: '',
        contactIndex: '',
        contactSubject: '',
        contactComment: '',
        SubjectErrorMessage: '',
        CommentErrorMessage: '',
        contactStatus: false,
      });
    }
  }

  onContactSubmit = async (event) => {
    event.preventDefault();
    if (this.state.contactSubject === '' && this.state.contactSubject.length < 1) {
      this.setState({
        displaytext: 'show_block',
        SubjectErrorMessage: "Subject can't be empty",
        isLoading: false,
      });
      return;
    }
    if (this.state.contactComment === '' && this.state.contactComment.length < 1) {
      this.setState({
        displaytext: 'show_block',
        CommentErrorMessage: "Comment can't be empty",
        isLoading: false,
      });
      return;
    }
    this.setState({
      isLoading: true,
    });
    const { idname, token, contactComment, contactSubject } = this.state;
    const data = {
      idname: idname,
      token: token,
      contactComment: contactComment,
      contactSubject: contactSubject,
    };
    await FD.callAPI(App_data.backend_api + '/contact_us/sendReportHelpRequest', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            validated: true,
            isLoading: false,
            successAlert: true,
          });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose = (e) => {
    this.setState({
      contactID: '',
      contactType: '',
      contactIndex: '',
      contactSubject: '',
      contactComment: '',
      contactStatus: false,
      successAlert: false,
      reportAnswerStatus: !this.state.reportAnswerStatus,
      reportAnswerId: '',
      type: '',
    });
  };

  async toggleDone() {
    const { idname, token, item_status, type, items_val } = this.state;
    const { question_id, item_id, video_id } = items_val;
    if (this.state.item_status == 'flashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      await FD.callAPI(App_data.backend_api + '/ea_question_bank/deleteFlashCard', data).then(
        async (resp) => {
          if (resp.success) {
            await this.getQuestionFlashcards();
          } else {
          }
        },
      );
    }
    if (item_status == 'savedquestion') {
      var data = {
        token,
        idname,
        save_question: items_val,
        type,
      };
      await this.deleteFlashCard('question', question_id ? question_id : item_id, type);
      await FD.callAPI(App_data.backend_api + '/ea_question_bank/deleteSavequestion', data).then(
        async (resp) => {
          if (resp.success) {
            await this.getQuestionsSaved();
          } else {
          }
        },
      );
    }

    if (item_status == 'savedvideos') {
      var data = {
        token,
        idname,
        save_question: items_val,
      };
      await this.deleteFlashCard('video', video_id ? video_id : item_id);
      await FD.callAPI(App_data.backend_api + '/ea_question_bank/deleteSaveVideo', data).then(
        async (resp) => {
          if (resp.success) {
            await this.getVideosSaved();
          } else {
          }
        },
      );
    }

    if (this.state.item_status == 'Videoflashcard') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        flash_card: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/ea_question_bank/deleteDashboardVideoFlashCard',
        data,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getVideoFlashcards();
        } else {
          //console.log('error');
        }
      });
    }

    if (this.state.item_status == 'Reportsquestion') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
        type: this.state.items_val.type,
      };
      await FD.callAPI(
        App_data.backend_api + '/ea_question_bank/deleteDashboardQuestionReports',
        data,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getQuestionReports();
        } else {
          //console.log('error');
        }
      });
    }

    if (this.state.item_status == 'Reportsvideos') {
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reports: this.state.items_val,
      };
      await FD.callAPI(
        App_data.backend_api + '/ea_question_bank/deleteDashboardVideoReports',
        data,
      ).then(async (resp) => {
        if (resp.success) {
          await this.getVideoReports();
        } else {
          //console.log('error');
        }
      });
    }

    this.setState({
      alert_status: false,
    });
  }

  handleChange(date) {
    this.setState({
      startDate: date,
      startDate_second: '',
      send_startDate: moment(date).format('YYYY-MM-DD'),
      subreadings_status: false,
    });
  }

  handleChange_second(date) {
    if (this.state.startDate != '') {
      this.setState(
        {
          startDate_second: date,
          send_startDate_second: moment(date).format('YYYY-MM-DD'),
          subreadings_status: true,
          display_main_loader: 'show_block',
        },
        function afterdateChange() {
          // console.log(
          //   'I am inside handleChange_second -----> ',
          //   this.state.toggle
          // );
          var data = {
            token: this.state.token,
            idname: this.state.idname,
            startDate: this.state.send_startDate,
            endDate: this.state.send_startDate_second,
            type: this.state.toggle ? 'content-type' : 'content-format',
          };

          // -------------- ---- FOR Main Graph No. 1 Start ------------- //
          FD.callAPI(App_data.backend_api + '/ea_dashboard/getMainGraphProgressbar', data).then(
            (resp) => {
              if (resp.success) {
                var dataStringGraph1 = JSON.stringify(resp.chapters);
                var dataReasonGraph1 = JSON.parse(dataStringGraph1);

                var final_array_main = [];

                for (i = 0; i < dataReasonGraph1.length; i++) {
                  var right_answered = dataReasonGraph1[i].answered_count;
                  var total_question = dataReasonGraph1[i].attempted_count;

                  var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(
                    1,
                  );

                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({
                  main_ea_bar_main_user: final_array_main,
                  display_main_loader: 'hide_block',
                  main_ea_progress_bar_zero: resp.chapters,
                });
              } else {
                this.setState({ display_main_loader: 'hide_block' });
              }
            },
          );
          FD.callAPI(
            App_data.backend_api + '/ea_dashboard/getMainGraphProgressClassbar',
            data,
          ).then((resp) => {
            if (resp.success) {
              var dataString = JSON.stringify(resp.chaptersclass);
              var dataReason = JSON.parse(dataString);
              var final_array_main = [];
              for (i = 0; i < dataReason.length; i++) {
                var right_answered = dataReason[i].answered_count;
                var total_question = dataReason[i].attempted_count;
                var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

                if (user_graph_val === 'NaN') {
                  final_array_main.push('0.0');
                } else {
                  final_array_main.push(user_graph_val);
                }
              }
              this.setState({ main_ea_bar_main_class: final_array_main });
            }
          });
          // -------------- ---- FOR Main Graph No. 1 End ------------- //
          FD.callAPI(App_data.backend_api + '/ea_dashboard/mainProgressbar', data).then((resp) => {
            if (resp.success) {
              var dataString = JSON.stringify(resp.chapters);
              var dataReason = JSON.parse(dataString);

              var final_array_main = [];

              for (i = 0; i < dataReason.length; i++) {
                var right_answered = dataReason[i].answered_count;
                var total_question = dataReason[i].attempted_count;

                var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

                if (user_graph_val === 'NaN') {
                  final_array_main.push('0.0');
                } else {
                  final_array_main.push(user_graph_val);
                }
              }

              this.setState({
                bar_main_user: final_array_main,
                display_main_loader: 'hide_block',
                progress_bar_zero: resp.chapters,
              });
              // console.log('part 22222---------------------', final_array_main);
            } else {
              this.setState({ display_main_loader: 'hide_block' });
            }
          });
          FD.callAPI(App_data.backend_api + '/ea_dashboard/mainProgressclassbar', data).then(
            (resp) => {
              if (resp.success) {
                var dataString = JSON.stringify(resp.chaptersclass);
                var dataReason = JSON.parse(dataString);
                var final_array_main = [];
                for (i = 0; i < dataReason.length; i++) {
                  var right_answered = dataReason[i].answered_count;
                  var total_question = dataReason[i].attempted_count;
                  var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(
                    1,
                  );

                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({ bar_main_class: final_array_main });
              } else {
                //console.log(resp.success + '------------failure');
              }
            },
          );

          // -------------- ---- FOR Verbal Graph No. 3 Start ------------- //
          FD.callAPI(App_data.backend_api + '/ea_dashboard/getVerbalProgressbar', data).then(
            (resp) => {
              if (resp.success) {
                var dataStringGraph3 = JSON.stringify(resp.chapters);
                var dataReasonGraph3 = JSON.parse(dataStringGraph3);

                var final_array_main = [];

                for (i = 0; i < dataReasonGraph3.length; i++) {
                  var right_answered = dataReasonGraph3[i].answered_count;
                  var total_question = dataReasonGraph3[i].attempted_count;

                  var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(
                    1,
                  );

                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({
                  verbal_bar_main_user: final_array_main,
                  display_main_loader: 'hide_block',
                  verbal_progress_bar_zero: resp.chapters,
                });
              } else {
                this.setState({ display_main_loader: 'hide_block' });
              }
            },
          );
          FD.callAPI(App_data.backend_api + '/ea_dashboard/getVerbalProgressclassbar', data).then(
            (resp) => {
              if (resp.success) {
                var dataStringGraph3 = JSON.stringify(resp.chaptersclass);
                var dataReasonGraph3 = JSON.parse(dataStringGraph3);
                var final_array_main = [];
                for (i = 0; i < dataReasonGraph3.length; i++) {
                  var right_answered = dataReasonGraph3[i].answered_count;
                  var total_question = dataReasonGraph3[i].attempted_count;
                  var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(
                    1,
                  );

                  if (user_graph_val === 'NaN') {
                    final_array_main.push('0.0');
                  } else {
                    final_array_main.push(user_graph_val);
                  }
                }
                this.setState({ verbal_bar_main_class: final_array_main });
              }
            },
          );
          // -------------- ---- FOR Verbal Graph No. 3 End ------------- //

          // -------------- ---- FOR Verbal Graph No. 4 Start ------------- //
          FD.callAPI(
            App_data.backend_api + '/ea_dashboard/getIntegratedReasoningProgressbar',
            data,
          ).then((resp) => {
            if (resp.success) {
              var dataStringGraph4 = JSON.stringify(resp.chapters);
              var dataReasonGraph4 = JSON.parse(dataStringGraph4);

              var final_array_main = [];

              for (i = 0; i < dataReasonGraph4.length; i++) {
                var right_answered = dataReasonGraph4[i].answered_count;
                var total_question = dataReasonGraph4[i].attempted_count;

                var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

                if (user_graph_val === 'NaN') {
                  final_array_main.push('0.0');
                } else {
                  final_array_main.push(user_graph_val);
                }
              }
              this.setState({
                integrated_reasoning_bar_main_user: final_array_main,
                display_main_loader: 'hide_block',
                integrated_reasoning_progress_bar_zero: resp.chapters,
              });
            } else {
              this.setState({ display_main_loader: 'hide_block' });
            }
          });
          FD.callAPI(
            App_data.backend_api + '/ea_dashboard/getIntegratedReasoningProgressclassbar',
            data,
          ).then((resp) => {
            if (resp.success) {
              var dataStringGraph4 = JSON.stringify(resp.chaptersclass);
              var dataReasonGraph4 = JSON.parse(dataStringGraph4);
              var final_array_main = [];
              for (i = 0; i < dataReasonGraph4.length; i++) {
                var right_answered = dataReasonGraph4[i].answered_count;
                var total_question = dataReasonGraph4[i].attempted_count;
                var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

                if (user_graph_val === 'NaN') {
                  final_array_main.push('0.0');
                } else {
                  final_array_main.push(user_graph_val);
                }
              }
              this.setState({
                integrated_reasoning_bar_main_class: final_array_main,
              });
            }
          });
          // -------------- ---- FOR Verbal Graph No. 4 End ------------- //
          // FD.callAPI(
          //   App_data.backend_api + '/ea_dashboard/getProgressChapter',
          //   data
          // ).then((resp) => {
          //   if (resp.success) {
          //     this.setState({ progress_bar_zero: resp.chapters });
          //   } else {
          //     //console.log(resp.success + '------------failure');
          //   }
          // });
          // FD.callAPI(
          //   App_data.backend_api + '/ea_dashboard/getNotesChapter',
          //   data
          // ).then((resp) => {
          //   if (resp.success) {
          //     this.setState({ bar_chapter: resp.chapters });
          //   } else {
          //     //console.log(resp.success + '------------failure');
          //   }
          // });
          FD.callAPI(App_data.backend_api + '/ea_dashboard/getQuestionProgByUser', data).then(
            (resp) => {
              if (resp.success) {
                this.setState({ progress_bar_zero: resp.progressbarzero_data });
              } else {
                //console.log(resp.success + '------------failure');
              }
            },
          );
        },
      );
    }
  }
  handleToggle = (event) => {
    const { checked } = event.target;
    this.setState({ toggle: checked }, () => {
      // console.log('type', checked, this.state.toggle);
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        type: checked ? 'content-type' : 'content-format',
        startDate: this.state.send_startDate,
        endDate: this.state.send_startDate_second,
      };
      // FD.callAPI(
      //   App_data.backend_api + '/ea_dashboard/getQuestionType',
      //   data
      // ).then(async (resp) => {
      //   // console.log(resp);
      //   let content_type = [];
      //   if (resp.success) {
      //     resp.question_type.map((question) => {
      //       content_type.push(question.content_type);
      //     });
      //     // content_type.push('Integrated Reasoning');

      //     this.setState({ content_type }, () => {
      //       this.contentTypeReportTabToggle(0);
      //       this.contentTypeTabToggle(0);
      //     });
      //   }
      // });
      // FD.callAPI(
      //   App_data.backend_api + '/ea_dashboard/mainProgressbar',
      //   data
      // ).then((resp) => {
      //   if (resp.success) {
      //     var dataString = JSON.stringify(resp.chapters);
      //     var dataReason = JSON.parse(dataString);

      //     var final_array_main = [];

      //     for (i = 0; i < dataReason.length; i++) {
      //       var right_answered = dataReason[i].answered_count;
      //       var total_question = dataReason[i].attempted_count;

      //       var user_graph_val = Math.round(
      //         (right_answered / total_question) * 100
      //       ).toFixed(1);

      //       if (user_graph_val === 'NaN') {
      //         final_array_main.push('0.0');
      //       } else {
      //         final_array_main.push(user_graph_val);
      //       }
      //     }

      //     this.setState({
      //       bar_main_user: final_array_main,
      //       display_main_loader: 'hide_block',
      //     });
      //     // console.log('part 22222---------------------', final_array_main);
      //   } else {
      //     this.setState({ display_main_loader: 'hide_block' });
      //   }
      // });
      // FD.callAPI(
      //   App_data.backend_api + '/ea_dashboard/mainProgressclassbar',
      //   data
      // ).then((resp) => {
      //   if (resp.success) {
      //     var dataString = JSON.stringify(resp.chaptersclass);
      //     var dataReason = JSON.parse(dataString);
      //     var final_array_main = [];
      //     for (i = 0; i < dataReason.length; i++) {
      //       var right_answered = dataReason[i].answered_count;
      //       var total_question = dataReason[i].attempted_count;
      //       var user_graph_val = Math.round(
      //         (right_answered / total_question) * 100
      //       ).toFixed(1);

      //       if (user_graph_val === 'NaN') {
      //         final_array_main.push('0.0');
      //       } else {
      //         final_array_main.push(user_graph_val);
      //       }
      //     }
      //     this.setState({ bar_main_class: final_array_main });
      //   } else {
      //     //console.log(resp.success + '------------failure');
      //   }
      // });
      FD.callAPI(App_data.backend_api + '/ea_dashboard/getQuestionProgByUser', data).then(
        (resp) => {
          if (resp.success) {
            this.setState({ progress_bar_zero: resp.progressbarzero_data });
          } else {
            //console.log(resp.success + '------------failure');
          }
        },
      );
    });
  };
  _deleteFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('flashcard');
  };

  _deleteVideoFlashcard = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Videoflashcard');
  };

  _deleteSavequestino = (items, e) => {
    // console.log('items --------> ', items);
    this.setState({ items_val: items });
    this.toggleAlert('savedquestion');
  };

  _deleteSaveVideo = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('savedvideos');
  };

  _deleteReportsquestino = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsquestion');
  };

  _deleteReportsVideo = (items, e) => {
    this.setState({ items_val: items });
    this.toggleAlert('Reportsvideos');
  };

  _getall = () => {
    if (this.state.show_outer == 'hide_block') {
      this.setState({ show_outer: 'show_block' });
      this.setState({ more_detail_button: 'Hide Details' });
    }
    if (this.state.show_outer == 'show_block') {
      this.setState({ show_outer: 'hide_block' });
      this.setState({ more_detail_button: 'I Want More Details' });
    }
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({ idname: storage_session['idname'] });
    this.setState({ token: storage_session['token'] });

    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      type: this.state.toggle ? 'content-type' : 'content-format',
    };
    // await FD.callAPI(
    //   App_data.backend_api + '/ea_dashboard/getQuestionType',
    //   data
    // ).then(async (resp) => {
    //   // console.log(resp);
    //   let content_type = [];
    //   if (resp.success) {
    //     resp.question_type.map((question) => {
    //       content_type.push(question.content_type);
    //     });
    //     // content_type.push('Integrated Reasoning');
    //     this.setState({ content_type });
    //   }
    // });
    await FD.callAPI(App_data.backend_api + '/ea_question_bank/getChapters', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({ chapters: resp.chapters });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );

    // -------------- ---- FOR Main Graph No. 1 Start ------------- //
    FD.callAPI(App_data.backend_api + '/ea_dashboard/getMainGraphProgressbar', data).then(
      (resp) => {
        if (resp.success) {
          var dataStringGraph1 = JSON.stringify(resp.chapters);
          var dataReasonGraph1 = JSON.parse(dataStringGraph1);

          var final_array_main = [];

          for (i = 0; i < dataReasonGraph1.length; i++) {
            var right_answered = dataReasonGraph1[i].answered_count;
            var total_question = dataReasonGraph1[i].attempted_count;

            var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

            if (user_graph_val === 'NaN') {
              final_array_main.push('0.0');
            } else {
              final_array_main.push(user_graph_val);
            }
          }
          this.setState({
            main_ea_bar_main_user: final_array_main,
            display_main_loader: 'hide_block',
            main_ea_progress_bar_zero: resp.chapters,
          });
        } else {
          this.setState({ display_main_loader: 'hide_block' });
        }
      },
    );
    FD.callAPI(App_data.backend_api + '/ea_dashboard/getMainGraphProgressClassbar', data).then(
      (resp) => {
        if (resp.success) {
          var dataString = JSON.stringify(resp.chaptersclass);
          var dataReason = JSON.parse(dataString);
          var final_array_main = [];
          for (i = 0; i < dataReason.length; i++) {
            var right_answered = dataReason[i].answered_count;
            var total_question = dataReason[i].attempted_count;
            var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

            if (user_graph_val === 'NaN') {
              final_array_main.push('0.0');
            } else {
              final_array_main.push(user_graph_val);
            }
          }
          this.setState({ main_ea_bar_main_class: final_array_main });
        }
      },
    );
    // -------------- ---- FOR Main Graph No. 1 End ------------- //
    await FD.callAPI(App_data.backend_api + '/ea_dashboard/mainProgressbar', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({ display_loader: 'hide_block' });
          var dataString = JSON.stringify(resp.chapters);
          var dataReason = JSON.parse(dataString);
          var final_array_main = [];
          for (i = 0; i < dataReason.length; i++) {
            var right_answered = dataReason[i].answered_count;
            var total_question = dataReason[i].attempted_count;
            var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

            if (user_graph_val === 'NaN') {
              final_array_main.push('0.0');
            } else {
              final_array_main.push(user_graph_val);
            }
          }
          // console.log('hi-------------------------', final_array_main);
          this.setState({ bar_main_user: final_array_main });
        } else {
          this.setState({ display_loader: 'hide_block' });
        }
      },
    );
    this.setState({ display_main_loader: 'show_block' });

    await FD.callAPI(App_data.backend_api + '/ea_dashboard/mainProgressclassbar', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({ display_main_loader: 'hide_block' });
          var dataStringGraph2 = JSON.stringify(resp.chaptersclass);
          var dataReasonGraph2 = JSON.parse(dataStringGraph2);

          var final_array_main = [];
          for (i = 0; i < dataReasonGraph2.length; i++) {
            var right_answered = dataReasonGraph2[i].answered_count;
            var total_question = dataReasonGraph2[i].attempted_count;
            var user_graph_val = ((right_answered / total_question) * 100).toFixed(1);

            if (user_graph_val === 'NaN') {
              final_array_main.push('0.0');
            } else {
              final_array_main.push(user_graph_val);
            }
          }
          this.setState({ bar_main_class: final_array_main });
        } else {
          this.setState({ display_loader: 'hide_block' });
        }
      },
    );

    // -------------- ---- FOR Verbal Graph No. 3 Start ------------- //
    FD.callAPI(App_data.backend_api + '/ea_dashboard/getVerbalProgressbar', data).then((resp) => {
      if (resp.success) {
        var dataStringGraph3 = JSON.stringify(resp.chapters);
        var dataReasonGraph3 = JSON.parse(dataStringGraph3);

        var final_array_main = [];

        for (i = 0; i < dataReasonGraph3.length; i++) {
          var right_answered = dataReasonGraph3[i].answered_count;
          var total_question = dataReasonGraph3[i].attempted_count;

          var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

          if (user_graph_val === 'NaN') {
            final_array_main.push('0.0');
          } else {
            final_array_main.push(user_graph_val);
          }
        }
        this.setState({
          verbal_bar_main_user: final_array_main,
          display_main_loader: 'hide_block',
          verbal_progress_bar_zero: resp.chapters,
        });
      } else {
        this.setState({ display_main_loader: 'hide_block' });
      }
    });
    FD.callAPI(App_data.backend_api + '/ea_dashboard/getVerbalProgressclassbar', data).then(
      (resp) => {
        if (resp.success) {
          var dataStringGraph3 = JSON.stringify(resp.chaptersclass);
          var dataReasonGraph3 = JSON.parse(dataStringGraph3);
          var final_array_main = [];
          for (i = 0; i < dataReasonGraph3.length; i++) {
            var right_answered = dataReasonGraph3[i].answered_count;
            var total_question = dataReasonGraph3[i].attempted_count;
            var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

            if (user_graph_val === 'NaN') {
              final_array_main.push('0.0');
            } else {
              final_array_main.push(user_graph_val);
            }
          }
          this.setState({ verbal_bar_main_class: final_array_main });
        }
      },
    );
    // -------------- ---- FOR Verbal Graph No. 3 End ------------- //

    // -------------- ---- FOR Verbal Graph No. 4 Start ------------- //
    FD.callAPI(App_data.backend_api + '/ea_dashboard/getIntegratedReasoningProgressbar', data).then(
      (resp) => {
        if (resp.success) {
          var dataStringGraph4 = JSON.stringify(resp.chapters);
          var dataReasonGraph4 = JSON.parse(dataStringGraph4);

          var final_array_main = [];

          for (i = 0; i < dataReasonGraph4.length; i++) {
            var right_answered = dataReasonGraph4[i].answered_count;
            var total_question = dataReasonGraph4[i].attempted_count;

            var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

            if (user_graph_val === 'NaN') {
              final_array_main.push('0.0');
            } else {
              final_array_main.push(user_graph_val);
            }
          }
          this.setState({
            integrated_reasoning_bar_main_user: final_array_main,
            display_main_loader: 'hide_block',
            integrated_reasoning_progress_bar_zero: resp.chapters,
          });
        } else {
          this.setState({ display_main_loader: 'hide_block' });
        }
      },
    );
    FD.callAPI(
      App_data.backend_api + '/ea_dashboard/getIntegratedReasoningProgressclassbar',
      data,
    ).then((resp) => {
      if (resp.success) {
        var dataStringGraph4 = JSON.stringify(resp.chaptersclass);
        var dataReasonGraph4 = JSON.parse(dataStringGraph4);
        var final_array_main = [];
        for (i = 0; i < dataReasonGraph4.length; i++) {
          var right_answered = dataReasonGraph4[i].answered_count;
          var total_question = dataReasonGraph4[i].attempted_count;
          var user_graph_val = Math.round((right_answered / total_question) * 100).toFixed(1);

          if (user_graph_val === 'NaN') {
            final_array_main.push('0.0');
          } else {
            final_array_main.push(user_graph_val);
          }
        }
        this.setState({
          integrated_reasoning_bar_main_class: final_array_main,
        });
      }
    });
    // -------------- ---- FOR Verbal Graph No. 4 End ------------- //
    await FD.callAPI(App_data.backend_api + '/ea_dashboard/getQuestionProgByUser', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            progress_bar_zero: resp.progressbarzero_data,
            qpLoader: false,
          });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );

    await FD.callAPI(App_data.backend_api + '/user/authtoken', data).then(async (resp) => {
      if (resp.success) {
        this.setState({ ValidToken: true });
      } else {
        this.setState({ ValidToken: false });
      }
    });

    const getProfileInfoData = {
      token: storage_session['token'],
      idname: storage_session['idname'],
    };
    // await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', getProfileInfoData).then(async (resp) => {
    this.dispose = autorun(async () => {
      const resp = userStore;
      if(resp == null || resp.profileInfo == null) return;

        if (resp.profileInfo) {
          this.setState({
            isVideo: resp.profileInfo.isVideo,
          });
        }
        if (resp.profileInfo.role === 'partner') {
          if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
            this.setState({
              showFreePremium: true,
            });
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });

            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              async (resp_exam) => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = await PartnerEASubscriptionCheck.checkEAVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  if (isInArray_var) {
                    this.setState({ showFreePremium: false });
                  } else {
                    this.setState({ showFreePremium: true });
                  }
                  // Question Subscription
                  let queSubscription =
                    await PartnerEASubscriptionCheck.checkEAQuestionSubscription(
                      selectedmen,
                      exam_data,
                      this.state.cfaUnlimitedPackage,
                      this.state.cfaUnlimitedActiveExam,
                    );
                  if (queSubscription) {
                    this.setState({ questionShowFreePremium: false });
                  } else {
                    this.setState({
                      questionShowFreePremium: true,
                    });
                  }
                } else {
                }
              },
            );
          }
        } else {
          if (
            resp.profileInfo.exam_selected === '' &&
            resp.profileInfo.cfaUnlimitedPackage == '' &&
            resp.profileInfo.cfaUnlimitedActiveExam == ''
          ) {
            this.setState({
              showFreePremium: true,
            });
          } else {
            var subscription_details = resp.profileInfo.subscription_details
              ? JSON.parse(resp.profileInfo.subscription_details)
              : resp.profileInfo.subscription_details;

            this.setState({
              subscription_details: subscription_details,
              cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
              cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
            });
            var data_arr = resp.profileInfo.exam_selected
              ? JSON.parse(resp.profileInfo.exam_selected)
              : null;
            var dataset = {
              token: this.state.token,
              idname: this.state.idname,
              examid: data_arr,
            };
            await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
              (resp_exam) => {
                if (resp_exam.success) {
                  var exam_data = resp_exam.examData;
                  var selectedmen = this.state.selectedmenu;
                  var isInArray_var = false;
                  isInArray_var = EASubscriptionCheck.checkEAVideosSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  // console.log("check video subscription in EA dashboard ", selectedmen,
                  // exam_data,
                  // this.state.cfaUnlimitedPackage,
                  // this.state.cfaUnlimitedActiveExam)
                  if (isInArray_var) {
                    this.setState({ showFreePremium: false });
                  } else {
                    this.setState({ showFreePremium: true });
                  }
                  let queSubscription = EASubscriptionCheck.checkEAQuestionSubscription(
                    selectedmen,
                    exam_data,
                    this.state.cfaUnlimitedPackage,
                    this.state.cfaUnlimitedActiveExam,
                  );
                  if (queSubscription) {
                    this.setState({
                      questionShowFreePremium: false,
                    });
                  } else {
                    this.setState({
                      questionShowFreePremium: true,
                    });
                  }
                } else {
                }
              },
            );
          }
        }
      },
    );

    await this.getQuestionFlashcards();
    await this.getVideoFlashcards();

    await this.getQuestionsSaved();
    await this.getVideosSaved();

    await this.getQuestionReports();
    await this.getVideoReports();
  }

  componentWillUnmount() {
    if(this.dispose) this.dispose();
  }

  // function for get  question report
  getQuestionReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    let { toggle, content_type, activeTabReportcards } = this.state;
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      // type: toggle
      //   ? `and content_type = '${
      //       content_type[activeTabReportcards ? activeTabReportcards : 0]
      //     }'`
      //   : `and content_format = '${
      //       content_type[activeTabReportcards ? activeTabReportcards : 0]
      //     }'`,
      type:
        content_type[activeTabReportcards ? activeTabReportcards : 0] === 'Quant'
          ? `and content_type != 'Verbal'`
          : `and content_type = '${content_type[activeTabReportcards ? activeTabReportcards : 0]}'`,
    };
    if (content_type[activeTabReportcards ? activeTabReportcards : 0] === 'Integrated Reasoning') {
      await FD.callAPI(
        App_data.backend_api + '/ea_question_bank/get4typesReportsQuestionsbyuserid',
        data,
      ).then(async (resp) => {
        if (resp.success) {
          this.setState({
            reportquestion: resp.questions,
            reportLoader: false,
          });
        }
      });
    } else {
      await FD.callAPI(
        App_data.backend_api + '/ea_question_bank/getReportsQuestionsbyuserid',
        data,
      ).then(async (resp) => {
        if (resp.success) {
          this.setState({
            reportquestion: resp.questions,
            reportLoader: false,
          });
        }
      });
    }
  };

  getQuestionFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/ea_question_bank/getFlashcardsbyuserid', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({
            flashreport: resp.flash_report,
            flashLoader: false,
          });
        }
      },
    );
  };

  getQuestionsSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    let { content_type, activeTabSavedcards, toggle } = this.state;
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
      // type: toggle
      //   ? `and content_type = '${
      //       content_type[activeTabSavedcards ? activeTabSavedcards : 0]
      //     }'`
      //   : `and content_format = '${
      //       content_type[activeTabSavedcards ? activeTabSavedcards : 0]
      //     }'`,
      type:
        content_type[activeTabSavedcards ? activeTabSavedcards : 0] === 'Quant'
          ? `and content_type != 'Verbal'`
          : `and content_type = '${content_type[activeTabSavedcards ? activeTabSavedcards : 0]}'`,
    };
    if (content_type[activeTabSavedcards ? activeTabSavedcards : 0] === 'Integrated Reasoning') {
      await FD.callAPI(
        App_data.backend_api + '/ea_question_bank/get4typesFavQuestionsbyuserid',
        data,
      ).then(async (resp) => {
        if (resp.success) {
          this.setState({
            savedquestion: resp.questions,
            savedLoader: false,
          });
        }
      });
    } else {
      await FD.callAPI(
        App_data.backend_api + '/ea_question_bank/getFavQuestionsbyuserid',
        data,
      ).then(async (resp) => {
        if (resp.success) {
          this.setState({
            savedquestion: resp.questions,
            savedLoader: false,
          });
        }
      });
    }
  };

  // function for get  Video falshCard
  getVideoFlashcards = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(
      App_data.backend_api + '/ea_question_bank/getFlashcardsVideobyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({ videoFlashReport: resp.flash_report });
      } else {
        //console.log(resp.success + '------------failure');
      }
    });
  };

  // function for get  video report
  getVideoReports = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/ea_question_bank/getReportsVideobyuserid', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({ reportsvideo: resp.video });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  /*
   * get saved all video
   */
  getVideosSaved = async () => {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      idname: storage_session['idname'],
      token: storage_session['token'],
    });
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      startDate: this.state.send_startDate,
      endDate: this.state.send_startDate_second,
    };
    await FD.callAPI(App_data.backend_api + '/ea_question_bank/getFavVideosbyuserid', data).then(
      async (resp) => {
        if (resp.success) {
          this.setState({ savedvideo: resp.cfa_videos });
        } else {
          //console.log(resp.success + '------------failure');
        }
      },
    );
  };

  /*
   * function for go to specific   question main page
   */
  _beginChapter = async (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.question_id,
    };
    if (item.type !== 'question') {
      let routeName;
      switch (item.type) {
        case 'tab_question':
          routeName = 'EA_TAB';
          break;
        case 'graph_question':
          routeName = 'EA_GRAPH_MULTI_STATEMENT';
          break;
        case 'table_question':
          routeName = 'EA_TABLE';
          break;
        case 'two_part_question':
          routeName = 'EA_TWO_PART_STATEMENT';
          break;
        default:
          console.log('Route Name issue');
          break;
      }
      var data = {
        token: this.state.token,
        idname: this.state.idname,
        reading_id: item.reading_id,
        question_type: item.type,
      };
      await FD.callAPI(
        App_data.backend_api + '/ea_question_bank/getSpecialQuestionByReadingId',
        data,
      ).then((resp) => {
        if (resp.success) {
          console.log('I am inside resp.success');
          resp.result.map((element, index) => {
            if (item.question_id === element.id) {
              this.context.router.push({
                pathname: AppRoutes[routeName]
                  .replace(':chapterid', element.ea_chapter_id)
                  .replace(':readingid', element.ea_reading_id)
                  .replace(':subscription', this.state.questionShowFreePremium === false ? 1 : 0)
                  .replace(':question_id', item.question_id)
                  .replace(':offset', index)
                  .replace(':reading', item.topic_name),
              });
            }
          });
        }
      });
    } else {
      let caseId = 0;
      let caseOffset = 0;
      FD.callAPI(App_data.backend_api + '/ea_question_bank/getQuestionsbyid', data).then((resp) => {
        if (resp.success) {
          // console.log('resp ----> ', resp.questionsbyid.case_id);
          console.log('callliiinnngggg.................IF.', this.state.questionShowFreePremium);
          if (resp.questionsbyid.case_id) {
            data['case_id'] = resp.questionsbyid.ea_case_id;
            data['reading_id'] = resp.questionsbyid.ea_reading_id;
            data['subscriptionstatus'] = this.state.questionShowFreePremium ? 'free' : 'paid';
            data['limit'] = 1;
            data['offset'] = 0;
            data['chapter_id'] = resp.questionsbyid.ea_chapter_id;
            // console.log(data);
            FD.callAPI(App_data.backend_api + '/ea_question_bank/getCaseByReading', data).then(
              (response) => {
                if (response.success) {
                  if (response.questions && response.questions.length) {
                    response.questions.map((elementCase, indexCase) => {
                      if (
                        parseInt(elementCase.case_id, 10) ===
                        parseInt(resp.questionsbyid.case_id, 10)
                      ) {
                        caseId = elementCase.case_id;
                        caseOffset = indexCase;
                        FD.callAPI(
                          App_data.backend_api + '/ea_question_bank/getCasesquestion',
                          data,
                        ).then((result) => {
                          console.log('result ------> ', result);
                          if (result.success) {
                            if (result.questions_details && result.questions_details.length) {
                              result.questions_details.map((element, index) => {
                                if (parseInt(element.id, 10) === parseInt(item.question_id, 10)) {
                                  this.context.router.push({
                                    pathname: AppRoutes.EA_BEGINCASE.replace(
                                      ':chapterid',
                                      element.ea_chapter_id,
                                    )
                                      .replace(':readingid', element.ea_reading_id)
                                      .replace(':caseid', element.ea_case_id)
                                      .replace(':case_offset', caseOffset)
                                      .replace(
                                        ':subscription',
                                        this.state.questionShowFreePremium ? 0 : 1,
                                      )
                                      .replace(
                                        ':question_number',
                                        // element.question_no
                                        index + 1,
                                      )
                                      .replace(':offset', index),
                                  });
                                }
                              });
                            }
                          }
                        });
                      }
                    });
                  }
                }
              },
            );
          } else {
            console.log('callliiinnngggg.................ELSE.');

            this.context.router.push({
              pathname: AppRoutes.EA_BEGINCHAPTER.replace(
                ':notesid',
                resp.questionsbyid.ea_chapter_id,
              )
                .replace(':readingid', resp.questionsbyid.ea_reading_id)
                .replace(':id', item.question_id),
            });
          }
        } else {
          //console.log('Not Found');
        }
      });
    }
  };

  _beginVideos = async (reading, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: reading.video_id,
      // chapter_id: reading.chapter_id
    };
    await FD.callAPI(App_data.backend_api + '/ea_question_bank/getVideoByID', data).then((resp) => {
      console.log(
        '----------->this.state.showFreePremium<-------------',
        this.state.showFreePremium,
      );
      if (resp.success) {
        let data = resp.allVideo.findIndex((item) => item.id === resp.video[0].id);
        this.context.router.push({
          pathname: AppRoutes.EA_VIDEO_DISPLAY.replace(':id', resp.video[0].id)
            .replace(':showFreePremium', this.state.showFreePremium ? 0 : 1)
            .replace(':type', resp.video[0].chapter_id === 0 ? 0 : 1)
            .replace(':chapter_id', resp.video[0].chapter_id)
            .replace(':index', data),
        });
      }
    });
  };

  questionProgressBarFun() {
    // console.log(
    //   'this.state.progress_bar_zero-------',
    //   this.state.progress_bar_zero
    // );
    return this.state.progress_bar_zero.map((item, index) => {
      var progressnotes_zero = Math.round((item.counttotquestion / item.question_stat_count) * 100);
      if (progressnotes_zero < 1) {
        progressnotes_zero = 1;
      }
      return (
        <tr key={index}>
          <td>
            <div className='question_row'>
              <div className='question_count'>Q.{index + 1}</div>
              <div className='question_bar'>
                <p>{item.chapter_name}</p>
                <div className='bar_wrap'>
                  <div>
                    <Progress
                      className='progress-xs'
                      color='info'
                      value={progressnotes_zero}
                      style={{ width: progressnotes_zero + '%' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
      );
    });
  }
  // question form submit function
  async handleQuestionReportSubmit(event) {
    event.preventDefault();
    if (this.state.quesReport === '' && this.state.quesReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, quesReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      quesReport: quesReport,
    };
    await FD.callAPI(
      App_data.backend_api + '/ea_question_bank/UpdateReportsQuestionsbyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          quesReport: '',
        });
        await this.getQuestionReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  // video form submit function
  async handleVideoReportSubmit(event) {
    event.preventDefault();
    if (this.state.videoReport === '' && this.state.videoReport.length < 1) {
      this.setState({
        displaytext: 'show_block',
        ErrorMessage: "Report can't be empty",
      });
      return;
    }
    const { reportEditId, idname, token, videoReport } = this.state;
    const data = {
      id: reportEditId,
      idname: idname,
      token: token,
      videoReport: videoReport,
    };
    await FD.callAPI(
      App_data.backend_api + '/ea_question_bank/UpdateReportsVideobyuserid',
      data,
    ).then(async (resp) => {
      if (resp.success) {
        this.setState({
          ValidToken: true,
          validated: true,
          reportEditStatus: !this.state.reportEditStatus,
          reportEditId: '',
          videoReport: '',
        });
        await this.getVideoReports();
      } else {
        this.setState({ ValidToken: false });
      }
      return resp;
    });
  }

  // function for state change of edit report form fileds
  InputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      ErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  SubjectInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      SubjectErrorMessage: '',
    });
  }

  // function for state change of edit report form fileds
  CommentInputChange(e) {
    const { target } = e;
    const { name, value } = target;
    this.setState({
      [name]: value,
      CommentErrorMessage: '',
    });
  }

  flashcardTabToggle = (tab) => {
    if (this.state.activeTabSavedcards !== tab) {
      this.setState({
        activeTabSavedcards: tab,
      });
    }
  };

  contentTypeTabToggle = (tab) => {
    if (this.state.activeTabSavedcards !== tab) {
      this.setState(
        {
          savedquestion: [],
          savedLoader: true,
          activeTabSavedcards: tab,
        },
        () => this.getQuestionsSaved(),
      );
    }
  };

  contentTypeReportTabToggle = (tab) => {
    if (this.state.activeTabReportcards !== tab) {
      // console.log('I am inside contentTypeTabToggle');
      this.setState(
        {
          reportquestion: [],
          reportLoader: true,
          activeTabReportcards: tab,
        },
        () => this.getQuestionReports(),
      );
    }
  };
  savedTabToggle = (tab) => {
    if (this.state.activeTabSaved !== tab) {
      this.setState({
        activeTabSaved: tab,
      });
    }
  };

  reportsTabToggle = (tab) => {
    if (this.state.activeTabReports !== tab) {
      this.setState({
        activeTabReports: tab,
      });
    }
  };

  render() {
    const {
      activeTabSavedcards,
      activeTabSaved,
      activeTabReports,
      isVideo,
      qpLoader,
      npLoader,
      savedLoader,
      flashLoader,
      reportLoader,
      toggle,
      activeTabReportcards,
    } = this.state;

    let flashreport_val = this.state.flashreport;
    let video_flashreport_val = this.state.videoFlashReport;

    let savedquestion_val = this.state.savedquestion;
    let savedvideo_val = this.state.savedvideo;

    let reportquestion_val = this.state.reportquestion;
    let reportvideo_val = this.state.reportsvideo;

    let flashcard_data = '';
    let video_flashcard_data = '';

    let savedquestion_data = '';
    let savedvideo_data = '';

    let question_reportsData = ''; // for question reports
    let video_reportsData = ''; // for video report

    // ------------------ FOR Graph 1 Start ----------------//
    let main_ea_bar_val = this.state.main_ea_progress_bar_zero;
    let main_ea_bar_percentage = this.state.main_ea_bar_main_user;

    let main_ea_bar_user_percentage = this.state.main_ea_bar_main_class;

    let main_ea_main_bar_data = [];
    var i = 0;
    main_ea_bar_val.map((data) => {
      main_ea_main_bar_data[i] = data.chapter_name;
      i++;
    });
    var main_ea_bar_data = {
      labels: main_ea_main_bar_data,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: main_ea_bar_percentage,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: main_ea_bar_user_percentage,
        },
      ],
    };
    // ------------------ FOR Graph 1 End ----------------//
    /*first main graph*/
    let main_bar_val = this.state.progress_bar_zero;
    let main_bar_percentage = this.state.bar_main_user;

    let main_bar_user_percentage = this.state.bar_main_class;
    let main_bar_data = [];
    var i = 0;
    Object.keys(main_bar_val).map(function (key) {
      // var dataStringGraph2 = JSON.stringify(main_bar_val[key]);
      // var dataReasonGraph2 = JSON.parse(dataStringGraph2);
      // console.log('dataReasonGraph2 parse------> ', dataReasonGraph2);
      // console.log('dataStringGraph2 stringify ------> ', dataReasonGraph2);

      if (
        main_bar_val[key].chapter_name !== 'Integrated Reasoning' &&
        main_bar_val[key].chapter_name !== 'Verbal'
      ) {
        if (main_bar_val[key].chapter_name) {
          main_bar_data[i] = main_bar_val[key].chapter_name;
          i++;
        }
      }
    });
    var bar_data = {
      labels: main_bar_data,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: main_bar_percentage,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: main_bar_user_percentage,
        },
      ],
    };
    // ------------------ FOR Graph 3 Start ----------------//
    let verbal_bar_val = this.state.verbal_progress_bar_zero;
    let verbal_bar_percentage = this.state.verbal_bar_main_user;

    let verbal_bar_user_percentage = this.state.verbal_bar_main_class;

    let verbal_main_bar_data = [];
    var i = 0;
    verbal_bar_val.map((data) => {
      verbal_main_bar_data[i] = data.chapter_name;
      i++;
    });
    var verbal_bar_data = {
      labels: verbal_main_bar_data,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: verbal_bar_percentage,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: verbal_bar_user_percentage,
        },
      ],
    };
    // ------------------ FOR Graph 3 End ----------------//

    // ------------------ FOR Graph 4 Start ----------------//
    let integrated_reasoning_bar_val = this.state.integrated_reasoning_progress_bar_zero;
    let integrated_reasoning_bar_percentage = this.state.integrated_reasoning_bar_main_user;

    let integrated_reasoning_bar_user_percentage = this.state.integrated_reasoning_bar_main_class;

    let integrated_reasoning_main_bar_data = [];
    var i = 0;
    integrated_reasoning_bar_val.map((data) => {
      integrated_reasoning_main_bar_data[i] = data.chapter_name.substring(0, 20);
      i++;
    });
    var integrated_reasoning_bar_data = {
      labels: integrated_reasoning_main_bar_data,
      datasets: [
        {
          label: 'You',
          backgroundColor: 'rgb(31,140,235)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(31,140,235)',
          data: integrated_reasoning_bar_percentage,
        },
        {
          label: 'AnalystPrep Users Average',
          backgroundColor: 'rgb(42,63,84)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgb(42,63,84)',
          data: integrated_reasoning_bar_user_percentage,
        },
      ],
    };

    // ------------------ FOR Graph 4 End ----------------//

    /*other graph*/
    // let chapters = this.state.progress_bar_zero;
    const { progress_bar_zero: chapters } = this.state;
    let reading_data = '';
    // alert(this.state.subreadings_status);
    if (this.state.progress_bar_zero.length && !this.state.subreadings_status) {
      chapters.reading_data = chapters.map((item, index) => (
        <div className='card' key={index}>
          <div className='card-header' key={item.id} value={item.id}>
            <a className='pointer_class' id={item.chapter_name} value={item.id}>
              {item.chapter_name}
            </a>
          </div>
          <div className='card-block' key={item.chapter_name} id={'bar_sub_item' + index}>
            {/*<Barget chapter_id={item.chapter_no}  idname={this.state.idname} token={this.state.token} answered_state={index} />*/}
          </div>
        </div>
      ));
    }
    if (this.state.progress_bar_zero.length && this.state.subreadings_status) {
      reading_data = chapters.map((item, index) => (
        <div className='col-sm-12' key={index}>
          <div className='card ' key={item.id}>
            <div className='card-header' key={item.id} value={item.id}>
              <a className='pointer_class' id={item.chapter_name} value={item.id}>
                {item.chapter_name}
              </a>
            </div>
            <div className='card-block' key={item.chapter_name} id={'bar_sub_item' + index}>
              {/*<Barget chapter_id={item.chapter_no}  idname={this.state.idname} token={this.state.token} answered_state={index} startDate={this.state.send_startDate} endDate={this.state.send_startDate_second} subreadings_status={this.state.subreadings_status}/>*/}
            </div>
          </div>
        </div>
      ));
    }

    if (this.state.flashreport.length) {
      flashcard_data = flashreport_val.map((items, index) => (
        <div id={'flash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else if (flashLoader) {
      flashcard_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.videoFlashReport.length) {
      video_flashcard_data = video_flashreport_val.map((items, index) => (
        <div id={'videoFlash_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginVideos.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteVideoFlashcard.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().Saved_Note}: </strong>
            {renderHTMLContent(items.flash_card, 'span')}
          </p>
        </div>
      ));
    } else {
      video_flashcard_data = <div className='text-center'>{language.LC().NO_FLASHCARDS}</div>;
    }

    if (this.state.savedquestion.length) {
      savedquestion_data = savedquestion_val.map((items, index) => (
        <div id={'savedque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSavequestino.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>
          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>
        </div>
      ));
    } else if (savedLoader) {
      savedquestion_data = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      savedquestion_data = <div className='text-center'> {language.LC().NO_SAVED_QUESTIONS} </div>;
    }

    if (this.state.savedvideo.length) {
      savedvideo_data = savedvideo_val.map((items, index) => (
        <div id={'savedvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginVideos.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteSaveVideo.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            {items.topic_name && (
              <div>
                <strong>{language.LC().TOPIC}: </strong>
                {renderHTMLContent(items.topic_name, 'span')}
              </div>
            )}
            {items.flash_card && (
              <div>
                <strong> Note: </strong>
                {renderHTMLContent(items.flash_card, 'span')}
              </div>
            )}
          </p>
        </div>
      ));
    } else {
      savedvideo_data = <div className='text-center'> {language.LC().NO_SAVED_VIDEO} </div>;
    }

    if (this.state.reportquestion.length) {
      question_reportsData = reportquestion_val.map((items, index) => (
        <div id={'reportsque_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().QUESTION_ID}: </strong> {items.question_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditQuesReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'quesReport'
              }
              toggle={this.OpenEditQuesReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditQuesReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleQuestionReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='quesReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.quesReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditQuesReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginChapter.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>
            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'quesReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                />
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'quesReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                Q. {items.question_id} {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactType === 'quesReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'quesReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'quesReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactType === 'quesReport' &&
                this.state.contactID === items.id &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsquestino.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else if (reportLoader) {
      question_reportsData = (
        <div className='card-block-loader'>
          <Loader />
        </div>
      );
    } else {
      question_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    if (this.state.reportsvideo.length) {
      video_reportsData = reportvideo_val.map((items, index) => (
        <div id={'reportsvideos_' + items.id} key={index} className='flash_card_box'>
          <div>
            <span>
              <strong> {language.LC().TICKET_ID}: </strong> {items.id}
            </span>

            <span
              className={`float-right status-${
                items.status === 'resolved' ? 'resolved' : 'pending'
              }`}
            >
              <strong className='text-capitalize'>
                {items.status === 'resolved' ? 'resolved' : 'pending'}
              </strong>
            </span>
          </div>

          <div className='mt-1'>
            <span>
              <strong> {language.LC().VIDEO_ID}: </strong> {items.video_id}
            </span>
            {!items.isSend && !items.answer && items.status !== 'resolved' ? (
              <span
                className='up tooltip-hover-questions float-right'
                style={{ padding: '10px' }}
                onClick={items.isSend ? null : this.OpenEditVideoReport.bind(this, items)}
                disabled={items.isSend}
              >
                <div className='tootip_box'> {language.LC().EDIT_REPORT} </div>{' '}
                <i className={this.state.EditCSS} aria-hidden='true' style={{ color: '#1f8ceb' }}>
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportEditStatus &&
                this.state.reportEditId === items.id &&
                this.state.type === 'videoReport'
              }
              toggle={this.OpenEditVideoReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items.video_id} {renderHTMLContent(items.topic_name, 'span')}
                <Button className='close' color='secondary' onClick={this.CloseEditVideoReport}>
                  ×
                </Button>
              </ModalHeader>
              <ModalBody>
                <div className='card-block'>
                  <form onSubmit={this.handleVideoReportSubmit.bind(this)}>
                    <div className='row'>
                      <div className='col-sm-12 margin_bottom_10'>
                        <textarea
                          id='comment'
                          name='videoReport'
                          rows='6'
                          className='form-control'
                          placeholder='Content..'
                          onChange={this.InputChange.bind(this)}
                          value={this.state.videoReport}
                        />
                        <span className={this.state.displaytext + ' text-danger'}>
                          {this.state.ErrorMessage}
                        </span>
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-sm-12 d-flex'>
                        <button type='submit' className='btn btn-primary active pointer_class'>
                          {' '}
                          {language.LC().UPDATE}
                        </button>

                        <button
                          type='button'
                          className='btn btn-danger active pointer_class margin_left_10'
                          onClick={this.CloseEditVideoReport}
                        >
                          {' '}
                          {language.LC().CANCEL}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </ModalBody>
            </Modal>

            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().VIEW} </div>
              <i
                onClick={this._beginVideos.bind(this, items)}
                className={this.state.viewCSS}
                style={{ color: '#1f8ceb' }}
              >
                {' '}
              </i>
            </span>

            {items.isSend && items.answer && items.answer.length > 0 ? (
              <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
                <div className='tootip_box'> {language.LC().VIEW_REPORTS_ANSWER} </div>
                <i
                  onClick={this.toggleAlertReport.bind(this, items, 'videoReport')}
                  className={this.state.viewREPORTCSS}
                  style={{ color: '#1f8ceb' }}
                >
                  {' '}
                </i>
              </span>
            ) : null}
            <Modal
              isOpen={
                this.state.reportAnswerStatus &&
                this.state.reportAnswerId === items.id &&
                this.state.type === 'videoReport'
              }
              toggle={this.toggleAlertReport}
              className={'modal-primary ' + this.props.className}
            >
              <ModalHeader>
                V. {items.video_id} {renderHTMLContent(items.topic_name, 'span')}
                <div className='contact-us-btn float-right'>
                  {this.state.contactStatus &&
                  this.state.contactType === 'videoReport' &&
                  this.state.contactID === items.id &&
                  this.state.contactIndex === index ? (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {language.LC().GO_TO_ANSWER}{' '}
                    </Button>
                  ) : (
                    <Button
                      className='btn btn-primary'
                      onClick={this.onContactChange.bind(this, items, index, 'videoReport')}
                    >
                      {' '}
                      <i className='fa fa-question-circle' aria-hidden='true' />{' '}
                      {language.LC().I_need_further_help}{' '}
                    </Button>
                  )}
                  <Button
                    className='close'
                    style={{ paddingLeft: '0.5rem', paddingTop: '0.5rem' }}
                    color='secondary'
                    onClick={this.toggleCloseReport}
                  >
                    ×
                  </Button>
                </div>
              </ModalHeader>
              <ModalBody>
                {this.state.contactStatus &&
                this.state.contactType === 'videoReport' &&
                this.state.contactID === items.id &&
                this.state.contactIndex === index ? (
                  !this.state.successAlert ? (
                    <form onSubmit={this.onContactSubmit.bind(this)}>
                      <div className='row'>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().SUBJECT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactSubject'
                            name='contactSubject'
                            rows='2'
                            className='form-control'
                            placeholder='Subject..'
                            onChange={this.SubjectInputChange.bind(this)}
                            value={this.state.contactSubject}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.SubjectErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <h6 className='mb-1 d-flex'>
                            {' '}
                            {language.LC().COMMENT}{' '}
                            <span className={this.state.displaytext + ' text-danger'}>*</span>
                          </h6>
                          <textarea
                            id='contactComment'
                            name='contactComment'
                            rows='6'
                            className='form-control'
                            placeholder='Comment..'
                            onChange={this.CommentInputChange.bind(this)}
                            value={this.state.contactComment}
                          />
                          <span className={this.state.displaytext + ' text-danger'}>
                            {this.state.CommentErrorMessage}
                          </span>
                        </div>
                        <div className='col-sm-12 d-flex align-items-center justify-content-center mt-1'>
                          <button type='submit' className='btn btn-primary active pointer_class'>
                            {' '}
                            {this.state.isLoading ? 'Please wait ...' : language.LC().SEND_REQUEST}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REQUEST_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {' '}
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                ) : (
                  <div className='text-center'>
                    <p className='margin_bottom_20'>
                      <span>{renderSanitizedHTML(items.answer)}</span>
                    </p>
                  </div>
                )}
              </ModalBody>
            </Modal>
            <span className='up tooltip-hover-questions float-right' style={{ padding: '10px' }}>
              <div className='tootip_box'> {language.LC().DELETE} </div>
              <i
                onClick={this._deleteReportsVideo.bind(this, items)}
                className={this.state.deleteCSS}
                style={{ color: '#f51a00' }}
              >
                {' '}
              </i>
            </span>
          </div>

          <p className='mt-1'>
            <strong> {language.LC().TOPIC}: </strong>
            {renderHTMLContent(items.topic_name, 'span')}
          </p>
          <p>
            <strong> {language.LC().REPORT}: </strong>
            <span>{renderSanitizedHTML(items.comment)}</span>
          </p>
        </div>
      ));
    } else {
      video_reportsData = <div className='text-center'> {language.LC().NO_REPORTS} </div>;
    }

    return (
      <div>
        <div className='animated fadeIn'>
          <EmailResubscribe />
          <div className='row'>
            <div className='col-sm-12 margin_bottom_20'>
              <div className='dashboard-top-head-section'>
                <h1 className='section_head'>Executive Assessment Dashboard</h1>
                {/* <div className='dashboard-right-side-btn'>
                  <button
                    className='btn btn-primary'
                    onClick={this._viewAllQuestion.bind()}
                  >
                    {' '}
                    {language.LC().Detailed_Stats}{' '}
                  </button>
                </div> */}
              </div>
            </div>
            <div className='col-lg-8'>
              <div className='card margin_bottom_20'>
                <div className='card-block'>
                  <div className='row'>
                    <div className='col-sm-1 text-md-right align-self-center'>
                      <label className='margin_bottom_0'>{language.LC().FROM}</label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          selected={this.state.startDate}
                          onChange={this.handleChange}
                          placeholderText='Select date'
                          width='100%'
                        />
                      </div>
                    </div>
                    <div className='col-sm-1 text-md-center align-self-center'>
                      <label className='margin_bottom_0'> {language.LC().TO} </label>
                    </div>
                    <div className='col-sm-5 align-self-center'>
                      <div className='datepicker_wrap'>
                        <div className='ico_box'>
                          <img
                            src={App_data.frontend_url + '/img/dashboard/calendar.svg'}
                            alt=''
                            width='14'
                          />
                        </div>
                        <DatePicker
                          placeholderText='Select date'
                          width='100%'
                          selected={this.state.startDate_second}
                          minDate={this.state.startDate}
                          onChange={this.handleChange_second.bind(this)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().PERFORMANCE_BY_AREA}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                  </div>

                  <div className='chart-wrapper performance-chart-wrapper'>
                    <Bar
                      data={main_ea_bar_data}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* -------------------- GRAPH 2 Start -------------------- */}
              <div className='card'>
                <div className='card-header'>
                  {language.LC().QUANT_PROBLEM}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                  </div>

                  <div className='chart-wrapper performance-chart-wrapper'>
                    <Bar
                      data={bar_data}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* -------------------- GRAPH 2 End ---------------------- */}

              {/* -------------------- GRAPH 3 Start -------------------- */}
              <div className='card'>
                <div className='card-header'>
                  {language.LC().VERBAL_PROBLEM}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                    {/* <i className='fa fa-spinner fa-spin ' /> */}
                  </div>

                  <div className='chart-wrapper performance-chart-wrapper'>
                    <Bar
                      data={verbal_bar_data}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* -------------------- GRAPH 3 End ---------------------- */}

              {/* -------------------- GRAPH 4 Start -------------------- */}
              <div className='card'>
                <div className='card-header'>
                  {language.LC().INTEGRATED_REASONING_QUESTIONS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='0'
                      id='0'
                      content={this.state.tooltips[0].placement}
                      place_tip={this.state.tooltips[0].text_align}
                    />
                  </div>
                </div>
                <div className='card-block'>
                  <div className={'main_loader ' + this.state.display_main_loader}>
                    <div className='loader-mid'>
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    </div>
                    {/* <i className='fa fa-spinner fa-spin ' /> */}
                  </div>

                  <div className='chart-wrapper performance-chart-wrapper'>
                    <Bar
                      data={integrated_reasoning_bar_data}
                      options={{
                        maintainAspectRatio: false,
                        ...Y_AXIS_SCALES,
                        tooltips: {
                          callbacks: {
                            label: function (tooltipItem, data) {
                              return (
                                data.datasets[tooltipItem.datasetIndex].label +
                                ': ' +
                                tooltipItem.yLabel +
                                '%'
                              );
                            },
                          },
                        },
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* -------------------- GRAPH 4 End ---------------------- */}
              <div className={this.state.show_outer} id='outer_readings_id' />

              {/* ----------------------- Flashcard ------------- */}

              {/* <div className='padding_bottom_30'>
                <h1 className='section_head padding_bottom_30'>
                  {language.LC().MY_FLASHCARDS}
                </h1>

                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul className='dashboard-card-header-tab'>
                    <li
                      onClick={() => {
                        this.flashcardTabToggle('1');
                      }}
                      className={activeTabSavedcards === '1' ? 'active' : ''}
                    >
                      <span> {language.LC().QUESTIONS}</span>
                    </li>

                    {this.state.isVideo ? (
                      <li
                        onClick={() => {
                          this.flashcardTabToggle('3');
                        }}
                        className={activeTabSavedcards === '3' ? 'active' : ''}
                      >
                        <span> {language.LC().VIDEOS} </span>
                      </li>
                    ) : null}
                  </ul>
                </div>
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabSavedcards === '1'
                        ? flashcard_data
                        : // : this.state.activeTabSavedcards === '2'
                          // ? notes_flashcard_data
                          video_flashcard_data}
                    </div>
                  </div>
                </div>
              </div> */}
              {/* ----------------------- Saved  ------------- */}

              <div className='padding_bottom_30'>
                {' '}
                <h1 className='section_head padding_bottom_30'>
                  {language.LC().MY_SAVED_ITEM_WITH_FLASH_CARD}
                </h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  {/* <ul className='dashboard-card-header-tab mb-1'> */}
                  <ul
                    className={`dashboard-card-header-tab ${activeTabSaved === '1' ? 'mb-1' : ''}`}
                  >
                    <li
                      onClick={() => {
                        this.savedTabToggle('1');
                      }}
                      className={activeTabSaved === '1' ? 'active' : ''}
                    >
                      <span style={{ height: 'auto' }}> {language.LC().QUESTIONS}</span>
                    </li>

                    {this.state.isVideo ? (
                      <li
                        onClick={() => {
                          this.savedTabToggle('3');
                        }}
                        className={activeTabSaved === '3' ? 'active' : ''}
                      >
                        <span> {language.LC().VIDEOS} </span>
                      </li>
                    ) : null}
                  </ul>
                </div>
                {/* ------------ Start ------------------- */}
                {activeTabSaved === '1' ? (
                  <div className='d-flex header-card-dashboard tab-header-wrap'>
                    <ul className='dashboard-card-header-tab'>
                      {this.state.content_type.map((item, index) => (
                        <li
                          onClick={() => {
                            this.contentTypeTabToggle(index);
                          }}
                          key={index}
                          className={activeTabSavedcards === index ? 'active' : ''}
                        >
                          <span> {item} </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
                {/* ------------ End ------------------- */}
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabSaved === '1'
                        ? savedquestion_data
                        : // : this.state.activeTabSaved === '2'
                          // ? savednotes_data
                          savedvideo_data}
                    </div>
                  </div>
                </div>
              </div>
              {/* ----------------------- Reports ------------- */}

              <div>
                <h1 className='section_head padding_bottom_30'>{language.LC().MY_REPORTS}</h1>
                <div className='d-flex header-card-dashboard tab-header-wrap'>
                  <ul
                    className={`dashboard-card-header-tab ${
                      activeTabReports === '1' ? 'mb-1' : ''
                    }`}
                  >
                    <li
                      onClick={() => {
                        this.reportsTabToggle('1');
                      }}
                      className={activeTabReports === '1' ? 'active' : ''}
                    >
                      <span style={{ height: 'auto' }}>{language.LC().QUESTIONS}</span>
                    </li>

                    {this.state.isVideo ? (
                      <li
                        onClick={() => {
                          this.reportsTabToggle('3');
                        }}
                        className={activeTabReports === '3' ? 'active' : ''}
                      >
                        <span> {language.LC().VIDEOS} </span>
                      </li>
                    ) : null}
                  </ul>
                </div>
                {/* ------------ Start ------------------- */}
                {activeTabReports === '1' ? (
                  <div className='d-flex header-card-dashboard tab-header-wrap'>
                    <ul className='dashboard-card-header-tab'>
                      {this.state.content_type.map((item, index) => (
                        <li
                          onClick={() => {
                            this.contentTypeReportTabToggle(index);
                          }}
                          key={index}
                          className={activeTabReportcards === index ? 'active' : ''}
                        >
                          <span> {item} </span>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : null}
                {/* ------------ End ------------------- */}
                <div className='card tab-body-wrap'>
                  <div className='card-block dashboard-cards-scroll my-1'>
                    <div className='chart-wrapper'>
                      {this.state.activeTabReports === '1'
                        ? question_reportsData
                        : // : this.state.activeTabReports === '2'
                          // ? notes_reportsData
                          this.state.activeTabReports === '3'
                          ? video_reportsData
                          : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-lg-4'>
              <div className='card'>
                <div className='card-header'>
                  {language.LC().QUESTION_PROGRESS}
                  <div className='card-actions card_action_tooltip float-right'>
                    <TooltipItem
                      key='1'
                      id='1'
                      content={this.state.tooltips[1].placement}
                      place_tip={this.state.tooltips[1].text_align}
                    />
                  </div>
                </div>
                <div className=''>
                  <table className='table table-hover mb-0 compress_table'>
                    {qpLoader ? (
                      <div className='card-block-loader'>
                        <Loader />
                      </div>
                    ) : (
                      <tbody>{this.questionProgressBarFun()}</tbody>
                    )}
                  </table>
                </div>
              </div>
            </div>
          </div>
          <Modal
            isOpen={this.state.alert_status}
            toggle={this.toggleAlert}
            className={'modal-primary ' + this.props.className}
          >
            <ModalHeader>
              {language.LC().ALERT}
              <Button className='close' color='secondary' onClick={this.toggleClose}>
                ×
              </Button>
            </ModalHeader>
            <ModalBody>
              <div className='text-center'>
                <p className='margin_bottom_20'>
                  <strong>{this.state.MessageContent}</strong>
                </p>
                <Button
                  className='btn btn-sm btn-primary'
                  color='primary'
                  onClick={this.toggleDone}
                >
                  {language.LC().OK}
                </Button>
              </div>
            </ModalBody>
          </Modal>
        </div>
        {this.state.display_loader === 'hide_block' ? null : <Loader />}
      </div>
    );
  }
}

var bar_data_sub = [];
var reading_text = '';
function Barget(props) {
  if (props.subreadings_status && props.endDate != '') {
    var data = {
      idname: props.idname,
      chapter_id: props.chapter_id,
      token: props.token,
      startDate: props.startDate,
      endDate: props.endDate,
    };
  } else {
    var data = {
      idname: props.idname,
      chapter_id: props.chapter_id,
      token: props.token,
      startDate: '',
      endDate: '',
    };
  }

  FD.callAPI(App_data.backend_api + '/ea_dashboard/subProgressbar', data).then((resp) => {
    FD.callAPI(App_data.backend_api + '/ea_dashboard/subProgressbarofclass', data).then(
      (resp_class) => {
        /*class variable */
        var dataString_class = JSON.stringify(resp_class.readingwisebar_ret_class);
        var dataReason_class = JSON.parse(dataString_class);

        var final_array_main_class = [];

        for (i = 0; i < dataReason_class.length; i++) {
          var right_answered_class = dataReason_class[i].right_answer;
          var total_question_class = dataReason_class[i].total_questions;
          var user_graph_val_class = ((right_answered_class / total_question_class) * 100).toFixed(
            2,
          );
          final_array_main_class.push(user_graph_val_class);
        }
        /*user variable*/
        var dataString = JSON.stringify(resp.readingwisebar_ret);
        var dataReason = JSON.parse(dataString);

        var final_array_main = [];
        var reading_text = [];

        for (i = 0; i < dataReason.length; i++) {
          var right_answered = dataReason[i].right_answer;
          var total_question = dataReason[i].total_questions;

          var user_graph_val = ((right_answered / total_question) * 100).toFixed(2);

          final_array_main.push(user_graph_val);
          reading_text.push(dataReason[i].reading);
        }

        bar_data_sub[props.answered_state] = {
          labels: reading_text,
          datasets: [
            {
              label: 'You',
              backgroundColor: 'rgb(114,195,250)',
              borderWidth: 1,
              hoverBackgroundColor: 'rgb(114,195,250)',
              data: final_array_main,
            },
            {
              label: 'AnalystPrep Users Average',
              backgroundColor: 'rgb(42,63,84)',
              borderWidth: 1,
              hoverBackgroundColor: 'rgb(42,63,84)',
              data: final_array_main_class,
            },
          ],
        };
      },
    );
  });
  return <Bar data={bar_data_sub[props.answered_state]} options={{ maintainAspectRatio: false }} />;
}

class TooltipItem extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      tooltipOpen: false,
    };
  }

  toggle() {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen,
    });
  }

  render() {
    return (
      <span>
        <img
          src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
          id={'Tooltip-' + this.props.id}
          width='18'
          alt=''
        />

        <Tooltip
          placement={this.props.place_tip}
          isOpen={this.state.tooltipOpen}
          target={'Tooltip-' + this.props.id}
          toggle={this.toggle}
        >
          <p className='tooltip_text'>{this.props.content}</p>
        </Tooltip>
      </span>
    );
  }
}
export default GMATDashboard;



// WEBPACK FOOTER //
// ./src/views/EA-Exams/Dashboard/dashboard.js